// extracted by mini-css-extract-plugin
module.exports = {"otpWrapper":"styles_otpWrapper___2Iy-1","otpInputWrapper":"styles_otpInputWrapper___926SD"};